import React from "react";
import { Grid2 } from "@mui/material";
import styles from "./SignUpAddonStyle.module.scss";

function SignUpAddon(props) {
  const { icon } = props;
  return (
    <Grid2 className={styles.mainContainer}>
      <Grid2 className={styles.addOnNameContainer}>
        <Grid2 className={styles.icon}>{icon}</Grid2>
        <Grid2 className={styles.label}>Addon's</Grid2>
      </Grid2>
      <hr className={styles.line} />
      <Grid2 className={styles.addonContainer}>
        <Grid2 className={styles.addonWaf}>
          <Grid2 className={styles.addonLabels}>
            <Grid2 className={styles.label}>WAF</Grid2>
            <Grid2 className={styles.freeLabel}>Free</Grid2>
          </Grid2>
          <Grid2 className={styles.addonLabels}>
            <Grid2 className={styles.addonText}>
              Protect your website from cyber threats with advanced security
              against DDoS attacks, SQL injections, and malware.
            </Grid2>
          </Grid2>
        </Grid2>
        {/* no staging add-on: new accounts build v2 (EBS) sites, which have no staging */}
      </Grid2>
    </Grid2>
  );
}

export default SignUpAddon;
